<template>
<div>

<h5 style="margin-top: 40px; text-align:center">
  {{$ml.get('yourpersonalkey')}} <span style="color:#2F90B0; margin-right:10px">{{streamKey}}</span>
  <b-button size="sm" variant="msstreamblue" @click="copyToClipboard(streamKey); showqk=true">
    <font-awesome-icon icon="clone"></font-awesome-icon> 
    {{$ml.get('copy')}}
  </b-button>
</h5>

<b-row class="justify-content-center">
  <code style="text-align:center; color: black" v-if="streamKey">
    quanteecKey: "{{ streamKey }}"
  </code>
</b-row>

<div style="margin: 2.5rem; text-align:center; border-bottom: 1px solid #2a5d77"></div>

<b-row class="justify-content-around align-items-center">
  <b-button :variant="(vplayer) ? 'greenw':'darkblue'" @click="vplayer=!vplayer; vtool=false; vcdn=false;">
    <font-awesome-icon icon="book-open" />
    {{$ml.get('videoplayerdoc')}}
  </b-button>
  <b-button :variant="(vtool) ? 'greenw':'darkblue'" @click="vtool=!vtool; vplayer=false; vcdn=false;">
    <font-awesome-icon icon="book-open" />
    {{$ml.get('visualizationtooldoc')}}
  </b-button>
  <b-button :variant="(vcdn) ? 'greenw':'darkblue'" @click="vplayer=false; vtool=false; vcdn=!vcdn">
    <font-awesome-icon icon="book-open" />
    {{$ml.get('needacdn')}}
  </b-button>
</b-row>

<b-row class="justify-content-center">
  <div style="margin: 2rem; width: 250px; text-align:center; border-bottom: 1px dashed #2a5d77"></div>
</b-row>

<b-row v-if="vplayer" class="justify-content-center align-items-center mb-3" style="font-size:12px">
  <h5 style="text-align:center">{{$ml.get('selectvideoplayer')}}</h5>
</b-row>

<b-row v-if="vplayer" class="align-items-center justify-content-around">
  <b-button :variant="(activePlugin === 'videojs') ? 'bordergreen':'emptyB'" @click="activePlugin = 'videojs'; line2_vjs_calc()" >
    <b-img height="30px" :src="require('@/assets/external_logo/videojs.svg')"></b-img>
  </b-button>
  <b-button :variant="(activePlugin === 'hlsjs') ? 'bordergreen':'emptyB'" @click="activePlugin = 'hlsjs'; line2_vjs_calc()">
    <b-img height="30px" :src="require('@/assets/external_logo/hlsjs.png')"></b-img>
  </b-button>
  <b-button :variant="(activePlugin === 'dashjs') ? 'bordergreen':'emptyB'" @click="activePlugin = 'dashjs'; line2_vjs_calc()">
    <b-img height="30px" :src="require('@/assets/external_logo/dashjs.png')"></b-img>
  </b-button>
  <b-button :variant="(activePlugin === 'rxplayer') ? 'bordergreen':'emptyB'" @click="activePlugin = 'rxplayer'; line2_vjs_calc()">
    <b-img height="30px" :src="require('@/assets/external_logo/rxplayer.png')"></b-img>
  </b-button>
  <b-button :variant="(activePlugin === 'bitmovin') ? 'bordergreen':'emptyB'" @click="activePlugin = 'bitmovin'; line2_vjs_calc()">
    <b-img height="30px" :src="require('@/assets/external_logo/bitmovin.png')"></b-img>
  </b-button>
  <b-button :variant="(activePlugin === 'shakaplayer') ? 'bordergreen':'emptyB'" @click="activePlugin = 'shakaplayer'; line2_vjs_calc()">
    <b-img height="30px" :src="require('@/assets/external_logo/shakaplayer.png')"></b-img>
  </b-button>
  <b-button :variant="(activePlugin.indexOf('flowplayer') > -1) ? 'bordergreen':'emptyB'" @click="activePlugin = 'flowplayernative'; line2_vjs_calc()">
    <b-img height="30px" :src="require('@/assets/external_logo/flowplayer.png')"></b-img>
  </b-button>
  <b-button :variant="(activePlugin === 'brightcove') ? 'bordergreen':'emptyB'" @click="activePlugin = 'brightcove'; line2_vjs_calc()">
    <b-img height="30px" :src="require('@/assets/external_logo/brightcove.png')"></b-img>
  </b-button>
</b-row>

<b-row v-if="vplayer" class="justify-content-center mt-4 mb-0">
  <h5 style="color:red; margin-bottom:0px">{{$ml.get('watchonce')}}</h5>
</b-row>

<b-row v-if="vplayer" class="justify-content-center">
  <div style="margin: 2rem; width: 250px; text-align:center; border-bottom: 1px dashed #2a5d77"></div>
</b-row>

<b-row v-if="vplayer" class="justify-content-center align-items-center mb-3" style="font-size:12px">
  <h5 style="text-align:center">{{$ml.get('supportedDRM')}}</h5>
</b-row>
<b-row v-if="vplayer" class="align-items-center justify-content-around mb-2">
    <b-img height="30px" :src="require('@/assets/external_logo/widevine-logo.svg')"></b-img>
    <b-img height="30px" :src="require('@/assets/external_logo/ms-playready.jpg')"></b-img>
    <b-img height="30px" :src="require('@/assets/external_logo/fairplay-drm.png')"></b-img>
</b-row>

<b-row v-if="vplayer" class="justify-content-center">
  <div style="margin: 2rem; width: 250px; text-align:center; border-bottom: 1px dashed #2a5d77"></div>
</b-row>


<b-row v-if="vplayer && (activePlugin === 'flowplayer' || activePlugin === 'flowplayernative')" class="justify-content-center marginalbotsm">
  <b-col cols="auto">
    <b-button @click="activePlugin = 'flowplayer'" :variant="(activePlugin === 'flowplayer') ? 'greenw':'msstreamblue'">v7</b-button>
    &nbsp;
    <b-button @click="activePlugin = 'flowplayernative'" :variant="(activePlugin !== 'flowplayer') ? 'greenw':'msstreamblue'" >Native</b-button>
  </b-col>
</b-row>
<b-row v-if="vplayer && (activePlugin === 'videojs' || activePlugin === 'videojsVHS')" class="justify-content-center marginalbotsm">
  <b-col cols="auto">
    <b-button @click="activePlugin = 'videojs'" :variant="(activePlugin === 'videojs') ? 'greenw':'msstreamblue'">HLS.js plugin</b-button>
    &nbsp;
    <b-button @click="activePlugin = 'videojsVHS'" :variant="(activePlugin !== 'videojs') ? 'greenw':'msstreamblue'">videojs-http-streaming</b-button>
  </b-col>
</b-row>

<b-row v-if="vplayer" class="justify-content-center align-items-center" style="font-size:12px">
  <b-col cols="12">
      <b-row class="justify-content-center align-items-center">
        <h5 style="text-align:center" v-if="activePlugin === 'videojs'" >QUANTEEC x Video.js</h5>
        <h5 style="text-align:center" v-if="activePlugin === 'videojsVHS'" >QUANTEEC x Video.js</h5>
        <h5 style="text-align:center" v-if="activePlugin === 'hlsjs'" >QUANTEEC x hls.js</h5>
        <h5 style="text-align:center" v-if="activePlugin === 'dashjs'" >QUANTEEC x dash.js</h5>
        <h5 style="text-align:center" v-if="activePlugin === 'rxplayer'" >QUANTEEC x rxPlayer</h5>
        <h5 style="text-align:center" v-if="activePlugin === 'bitmovin'" >QUANTEEC x Bitmovin</h5>
        <h5 style="text-align:center" v-if="activePlugin === 'shakaplayer'" >QUANTEEC x shaka player</h5>
        <h5 style="text-align:center" v-if="activePlugin === 'flowplayer'" >QUANTEEC x flowplayer 7</h5>
        <h5 style="text-align:center" v-if="activePlugin === 'flowplayernative'" >QUANTEEC x flowplayer native</h5>
        <h5 style="text-align:center" v-if="activePlugin === 'brightcove'" >QUANTEEC x Brightcove</h5>
      </b-row>
      <b-row class="justify-content-center align-items-center">
        <p style="margin-bottom:0px" v-if="activePlugin === 'videojs'" v-html="$ml.get('pluginp1')">
            
        </p>
        <p style="margin-bottom:0px" v-if="activePlugin === 'videojsVHS'" v-html="$ml.get('pluginp1_1')">
            
        </p>
        <p style="margin-bottom:0px" v-if="activePlugin === 'hlsjs'" v-html="$ml.get('pluginp2')">
            
        </p>
        <p style="margin-bottom:0px" v-if="activePlugin === 'dashjs'" v-html="$ml.get('pluginp3')">
            
        </p>
        <p style="margin-bottom:0px" v-if="activePlugin === 'rxplayer'" v-html="$ml.get('pluginp21')">
            
        </p>
        <p style="margin-bottom:0px" v-if="activePlugin === 'bitmovin'" v-html="$ml.get('pluginp22')">
            
        </p>
        <p style="margin-bottom:0px" v-if="activePlugin === 'shakaplayer'" v-html="$ml.get('pluginp4')">
            
        </p>
        <p style="margin-bottom:0px" v-if="activePlugin === 'flowplayer'" v-html="$ml.get('pluginp5')">
            
        </p>
        <p style="margin-bottom:0px" v-if="activePlugin === 'flowplayernative'" v-html="$ml.get('pluginp6')">
            
        </p>
        <p style="margin-bottom:0px" v-if="activePlugin === 'brightcove'" v-html="$ml.get('pluginp7')">
            
        </p>
      </b-row>
      <b-row class="justify-content-center align-items-center">
        <ol class="center" style="margin: 10px">
          <li v-if="activePlugin === 'videojs'" style="margin-bottom:10px">
              {{$ml.get('pluginp8')}}<br />
              <code>
                {{line1_vjs}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line1_vjs)" />
          </li>
          <li v-if="activePlugin === 'videojsVHS'" style="margin-bottom:10px">
              {{$ml.get('pluginp8')}}<br />
              <code>
                {{line1_vjsvhs}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line1_vjsvhs)" />
          </li>
          <li v-if="activePlugin === 'hlsjs'" style="margin-bottom:10px">
              {{$ml.get('pluginp8')}}<br />
              <code>
                {{line1_hls}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line1_hls)" />
          </li>
          <li v-if="activePlugin === 'dashjs'" style="margin-bottom:10px">
              {{$ml.get('pluginp8')}}<br />
              <code>
                {{line1_dashjs}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line1_dashjs)" />
          </li>
          <li v-if="activePlugin === 'rxplayer'" style="margin-bottom:10px">
              {{$ml.get('pluginp8')}}<br />
              <code>
                {{line1_rx}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line1_rx)" />
          </li>
          <li v-if="activePlugin === 'bitmovin'" style="margin-bottom:10px">
              {{$ml.get('pluginp8')}}<br />
              <code>
                {{line1_bitmovin}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line1_bitmovin)" />
          </li>
          <li v-if="activePlugin === 'shakaplayer'" style="margin-bottom:10px">
              {{$ml.get('pluginp8')}}<br />
              <code>
                {{line1_shaka}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line1_shaka)" />
          </li>
          <li v-if="activePlugin.indexOf('flowplayer') > -1" style="margin-bottom:10px">
              {{$ml.get('pluginp8')}}<br />
              <code>
                {{line1_flow}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line1_flow)" />
          </li>
          <li v-if="activePlugin === 'brightcove'" style="margin-bottom:10px">
              {{$ml.get('pluginp9')}}<br />
              <code>
                {{line1_bright}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line1_bright)" />
          </li>

          <li v-if="activePlugin === 'brightcove'" style="margin-bottom:10px">
              <span v-html="$ml.get('pluginp10')"></span><br />
              <code>{{line2_bright}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line2_vjs)" />
          </li>
          <li v-if="activePlugin === 'videojs' || activePlugin === 'videojsVHS' || activePlugin === 'hlsjs' || activePlugin === 'dashjs' ||  activePlugin === 'rxplayer' || activePlugin === 'bitmovin' ||activePlugin === 'shakaplayer' || activePlugin.indexOf('flowplayer') > -1" style="margin-bottom:10px">
              {{$ml.get('pluginp11')}}<br /> 
              <code>{{line2_vjs}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line2_vjs)" />
          </li>

          <li v-if="activePlugin === 'videojs'" style="margin-bottom:10px">
              {{$ml.get('pluginp12')}}<br />
              <code>
                {{line3_vjs}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line3_vjs)" />
          </li>
          <li v-if="activePlugin === 'videojs'" style="margin-bottom:10px">
              {{$ml.get('pluginp13')}}<br />
              <code>
                {{line4_vjs}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line4_vjs)" />
          </li>
          <li v-if="activePlugin === 'videojsVHS'" style="margin-bottom:10px">
              {{$ml.get('pluginp1_2')}}<br />
              <code>
                {{line3_vjsvhs}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line3_vjsvhs)" />
          </li>
          <li v-if="activePlugin === 'hlsjs'" style="margin-bottom:10px">
              {{$ml.get('pluginp14')}}<br />
              <code>
                {{line3_hls}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line3_hls)" />
          </li>
          <li v-if="activePlugin === 'dashjs'" style="margin-bottom:10px">
              {{$ml.get('pluginp15')}}<br />
              <code>
                {{line3_dashjs}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line3_dashjs)" />
          </li>

          <li v-if="activePlugin === 'rxplayer'" style="margin-bottom:10px">
              {{$ml.get('pluginp23')}}<br />
              <code>
                {{line3_rx}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line3_rx)" />
          </li>
          <li v-if="activePlugin === 'bitmovin'" style="margin-bottom:10px">
              {{$ml.get('pluginp24')}}<br />
              <code>
                {{line3_bitmovin}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line3_bitmovin)" />
          </li>
          
          <li v-if="activePlugin === 'shakaplayer'" style="margin-bottom:10px">
              {{$ml.get('pluginp16')}}<br />
              <code>
                {{line3_shaka}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line3_shaka)" />
          </li>
          <li v-if="activePlugin.indexOf('flowplayer') > -1" style="margin-bottom:10px">
              {{$ml.get('pluginp17')}}<br />
              <code>
                {{line3_flow}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line3_flow)" />
          </li>
          <li v-if="activePlugin === 'flowplayernative'" style="margin-bottom:10px">
              {{$ml.get('pluginp18')}}<br />
              <code>
                {{line4_flownative}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line4_flownative)" />
          </li>
          <li v-if="activePlugin.indexOf('flowplayer') > -1" style="margin-bottom:10px">
              {{$ml.get('pluginp19')}}<br />
              <code>
                {{line4_flow}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line4_flow)" />
          </li>
          <li v-if="activePlugin === 'brightcove'" style="margin-bottom:10px">
              {{$ml.get('pluginp20')}}<br />
              <code>
                {{line3_bright}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="copyToClipboard(line3_bright)" />
          </li>

        </ol>
      </b-row>
  </b-col>
  <div v-if="streamKey">
    <Videojs v-if="vplayer && activePlugin === 'videojs'" :streamKey="streamKey"></Videojs>
    <VideojsVHS v-if="vplayer && activePlugin === 'videojsVHS'" :streamKey="streamKey"></VideojsVHS>
    <Hlsjs v-if="vplayer && activePlugin === 'hlsjs'" :streamKey="streamKey"></Hlsjs>
    <Dashjs v-if="vplayer && activePlugin === 'dashjs'" :streamKey="streamKey"></Dashjs>
    <RxPlayer v-if="vplayer && activePlugin === 'rxplayer'" :streamKey="streamKey"></RxPlayer>
    <Bitmovin v-if="vplayer && activePlugin === 'bitmovin'" :streamKey="streamKey"></Bitmovin>
    <Flowplayer v-if="vplayer && activePlugin === 'flowplayer'" :streamKey="streamKey"></Flowplayer>
    <FlowplayerNative v-if="vplayer && activePlugin === 'flowplayernative'" :streamKey="streamKey"></FlowplayerNative>
    <ShakaPlayer v-if="vplayer && activePlugin === 'shakaplayer'" :streamKey="streamKey"></ShakaPlayer>
    <Brightcove v-if="vplayer && activePlugin === 'brightcove'"></Brightcove>
  </div>

</b-row>

<b-row v-if="vtool" class="justify-content-center align-items-center">
  <b-col cols="12">
      <b-row class="justify-content-center align-items-center">
        <h5 style="text-align:center" ></h5>
      </b-row>
  </b-col>

  <VisualizationTool v-if="vtool"></VisualizationTool>
</b-row>

<b-row v-if="vcdn" class="marginalbot">
  <b-col cols="12">
    <CDNDoc></CDNDoc>
    <CustomCDN class="myBorder"></CustomCDN>
    <b-row class="justify-content-center">
      <div style="margin: 2rem; width: 250px; text-align:center; border-bottom: 1px dashed #2a5d77"></div>
    </b-row>
    <CDNDoc2></CDNDoc2>
  </b-col>
</b-row>


    <b-modal ref="ErrorVideos" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('Error')}}</h3>
      </div>
      <p>{{$ml.get('pleaseretry')}}</p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="quanteec" block @click="hideModal('ErrorVideos')">Ok</b-btn>
      </b-row>
  </b-modal>

  <b-modal ref="copied" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>{{$ml.get('copied')}}</h3>
      </div>
      <p>{{$ml.get('selectedtextcopied')}}</p>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="msstreamblue" block @click="cleanMyTimeout();hideModal('copied')">Ok</b-btn>
      </b-row>
  </b-modal>

</div>
</template>

<script>
import VisualizationTool from '@/components/documentation/plugins/VisualizationTool.vue';
import Videojs from '@/components/documentation/plugins/Videojs.vue';
import VideojsVHS from '@/components/documentation/plugins/VideojsVHS.vue';
import Hlsjs from '@/components/documentation/plugins/Hlsjs.vue';
import Dashjs from '@/components/documentation/plugins/Dashjs.vue';
import RxPlayer from '@/components/documentation/plugins/RxPlayer.vue';
import Bitmovin from '@/components/documentation/plugins/Bitmovin.vue';
import Flowplayer from './documentation/plugins/Flowplayer.vue';
import FlowplayerNative from './documentation/plugins/FlowplayerNative.vue';
import ShakaPlayer from './documentation/plugins/ShakaPlayer.vue';
import Brightcove from './documentation/plugins/Brightcove.vue';
import CDNDoc from '@/components/documentation/CDNDoc.vue';
import CDNDoc2 from '@/components/documentation/CDNDoc2.vue';
import CustomCDN from '@/components/CustomCDN.vue';

import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
import ClientService from '@/services/client.service'
var clientService = new ClientService()
import {v4 as uuidv4} from 'uuid';
export default {
  name: 'PlugIn',
  data: function() {
    return {
      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      streamKey: '',
      authorizedVideos: [],
      authorizedVideosTags: [],
      modifyAuthorizedVideos: false,
      authorizedIPs: [],
      authorizedIPsTags: [],
      modifyAuthorizedIPs: false,
      unauthorizedIPs: [],
      unauthorizedIPsTags: [],
      modifyUnauthorizedIPs: false,
      authorizedCountries: [],
      authorizedCountriesTags: [],
      modifyAuthorizedCountries: false,
      unauthorizedCountries: [],
      unauthorizedCountriesTags: [],
      modifyUnauthorizedCountries: false,
      showqk: false,
      timeout: null,
      iceConfig: 'ice1',
      iceConfigReceived: 'ice1',
      customIce: [],
      customIceReceived: [],
      authorizedVPNs: true,
      authorizedVPNsList:[],
      authorizedVPNsTags: [],
      modifyAuthorizedVPNs:false,
      vtool:false,
      vplayer:true,
      vcdn: false,
      
      activePlugin: '',
      line1_vjs: '<script src="https://files.quanteec.com/quanteec/latest/videojs-quanteec-plugin.js"><'+'/script>',
      line1_vjsvhs: '<script src="https://files.quanteec.com/quanteec/latest/quanteec-vhs.min.js"><'+'/script>',
      line3_vjsvhs: 'var quanteecPlayer = new Quanteec(configQuanteec, player);',
      line2_vjs: '',
      line3_vjs: 'var vjsObject = { html5: { quanteec: configQuanteec } }',
      line4_vjs: 'quanteecSourceHandler.register();',
      line1_hls: '<script src="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js"><'+'/script>',
      line3_hls: 'var quanteecPlayer = new Quanteec(configQuanteec, hlsPlayer);',
      line1_dashjs: '<script src="https://files.quanteec.com/quanteec/latest/quanteec-dashjs.min.js"><'+'/script>',
      line3_dashjs: 'var quanteecPlayer = new Quanteec(configQuanteec, dashPlayer);',
      line1_flow: '<script src="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js"><'+'/script>',
      line3_flow: 'var quanteecPlayer = new Quanteec(configQuanteec, flowplayer);',
      line4_flownative: 'hls: { pLoader: quanteecPlayer.loader, fLoader: quanteecPlayer.loader}',
      line4_flow: 'quanteecPlayer.setFlowplayer(flow);',
      line1_bright: 'https://quanteec.com/js/latest/videojs-quanteec-plugin.js',
      line2_bright: 'quanteec',
      line3_bright: '',
      line1_shaka: '<script src="https://files.quanteec.com/quanteec/latest/quanteec-shaka.min.js"><'+'/script>',
      line3_shaka: 'var quanteecPlayer = new Quanteec(configQuanteec, shakaPlayer);',
      line1_rx: '<script src="https://files.quanteec.com/quanteec/latest/quanteec-rxplayer.min.js"><'+'/script>',
      line3_rx: 'var quanteecPlayer = new Quanteec(configQuanteec, rxPlayer);',
      line1_bitmovin: '<script src="https://files.quanteec.com/quanteec/latest/quanteec-bitmovin.min.js"><'+'/script>',
      line3_bitmovin: 'var quanteecPlayer = new Quanteec(configQuanteec, bitmovinPlayer);',
    }
  },
  components: {
      VisualizationTool,
      VueMarkdown,
      Videojs,
      VideojsVHS,
      Hlsjs,
      Dashjs,
      RxPlayer,
      Bitmovin,
      Flowplayer,
      FlowplayerNative,
      ShakaPlayer,
      Brightcove,
      CustomCDN,
      CDNDoc,
      CDNDoc2
  },
  mounted: function() {
    this.getAuthorizations();
    this.getStreamKeys();
    this.getClientIceClient();
    this.getClientIce();
    this.$nextTick(() => {
        Prism.highlightAll()
      });
  },
  computed: {
    customIce_computed() {
      return JSON.stringify(this.customIce);
    },
    customIceReceived_computed() {
      return JSON.stringify(this.customIceReceived);
    },
  },
  methods: {
    line2_vjs_calc() {
      this.line2_vjs = 'var configQuanteec = { quanteecKey: "'+this.streamKey+'" };';
      this.line3_bright = '{ quanteecKey: "'+this.streamKey+'" }';
    },

    addUrl(ice) {
      ice.urls.push('');
    },
    removeUrl(ice, idx) {
      ice.urls.splice(idx, 1);
    },
    addSTUN() {
      this.customIce.push({_id: uuidv4(), urls: ['']});
    },
    addTURN() {
      this.customIce.push({_id: uuidv4(), urls: [''], username: '', credential: '', _showCredential: 'password'});
    },
    removeICE(indexIce) {
      this.customIce.splice(indexIce, 1);
    },
    cleanMyTimeout() {
      try {
        clearTimeout(this.timeout);
      } catch(err) {}
    },
    copyToClipboard(text) {
      this.cleanMyTimeout();
      this.$copyText(text);
      this.showModal("copied");
      this.timeout = setTimeout(this.hideModal, 1.5 * 1000, 'copied');
    },
    getStreamKeys() {
      clientService.getClientStreamKeys(this.clientView, this.$auth.token()).then(keys => {
        this.streamKey = keys.keys[0];
      }).catch(err => {
        console.log(err);
      })
    },
    getClientIceClient(){
      clientService.getClientIceClient(this.clientView, this.$auth.token()).then(data => {
        this.iceConfig = data.key || data;
        this.iceConfigReceived = data.key || data;
      }).catch(err => {
        console.log(err);
      })
    },
    putClientIce(){
      clientService.putClientIce(this.clientView, {ice: this.iceConfig}, this.$auth.token()).then(data => {
        this.iceConfigReceived = this.iceConfig;
      }).catch(err => {
        this.iceConfig = this.iceConfigReceived;
        this.showModal("ErrorVideos");
      })
    },
    refreshClientIce() {
      this.iceConfig = this.iceConfigReceived;
    },
    getClientIce(){
      clientService.getClientIce(this.clientView, this.$auth.token()).then(data => {
        if (data !== "" && data.ice) {
          data.ice.forEach(x => {
            x._id = uuidv4();
            if (x.credential !== undefined) {
              x._showCredential = "password";
            }
          })
          this.customIce = JSON.parse(JSON.stringify(data.ice));
          this.customIceReceived = JSON.parse(JSON.stringify(data.ice));
        } else {
          this.customIce = [];
          this.customIceReceived = [];
        }
      }).catch(err => {
        console.log(err);
      })
    },
    postClientIce(){
      let result = this.customIce.map(x => {
         let myResult = {
           urls: x.urls
         }
         if (x.credential !== undefined) {
           myResult.username = x.username;
           myResult.credential = x.credential;
         }
         return myResult;
      })
      clientService.postClientIce(this.clientView, {ice: result}, this.$auth.token()).then(data => {
        this.customIceReceived = JSON.parse(JSON.stringify(this.customIce));
      }).catch(err => {
        this.showModal("ErrorVideos");
      })
    },
    refreshClientIceClient() {
      this.customIce = JSON.parse(JSON.stringify(this.customIceReceived));
    },
    getAuthorizations() {
      clientService.getClientAuthorizations(this.clientView, this.$auth.token()).then(auths => {

        console.log(auths)

        this.authorizedVideos = auths.authorizedVideos;
        this.authorizedVideosTags = auths.authorizedVideos.map(x => {return {key: x, value: x}});

        this.authorizedIPs = auths.authorizedIPs;
        this.authorizedIPsTags = auths.authorizedIPs.map(x => {return {key: x, value: x}});

        this.unauthorizedIPs = auths.unauthorizedIPs;
        this.unauthorizedIPsTags = auths.unauthorizedIPs.map(x => {return {key: x, value: x}});

        this.authorizedCountries = auths.authorizedCountries;
        this.authorizedCountriesTags = auths.authorizedCountries.map(x => {return {key: x, value: x}});

        this.unauthorizedCountries = auths.unauthorizedCountries;
        this.unauthorizedCountriesTags = auths.unauthorizedCountries.map(x => {return {key: x, value: x}});

        this.authorizedVPNs = auths.authorizedVPNs;

        this.authorizedVPNsList = auths.authorizedVPNsList;
        this.authorizedVPNsTags = auths.authorizedVPNsList.map(x=>{return {key:x, value:x}});
       
      }).catch(err => {
        console.log(err);
      })
    },
    updateAuthorizedVideos() {
      let newData = this.authorizedVideosTags.map(x => x.value);
      clientService.putClientAuthorizedVideos(this.clientView, {authorizedVideos:newData}, this.$auth.token()).then(auths => {
        this.authorizedVideos = auths.authorizedVideos;
        this.modifyAuthorizedVideos = false;
      }).catch(err => {
       this.showModal("ErrorVideos");
      })
    },
    cancelAuthorizedVideos() {
      this.authorizedVideosTags = this.authorizedVideos.map(x => {return {key: x, value: x}}); 
      this.modifyAuthorizedVideos = false;
    },

    updateAuthorizedIPs() {
      let newData = this.authorizedIPsTags.map(x => x.value);
      clientService.putClientAuthorizedIPs(this.clientView, {authorizedIPs:newData}, this.$auth.token()).then(auths => {
        this.authorizedIPs = auths.authorizedIPs;
        this.modifyAuthorizedIPs = false;
      }).catch(err => {
        this.showModal("ErrorVideos");
      })
    },
    cancelAuthorizedIPs() {
      this.authorizedIPsTags = this.authorizedIPs.map(x => {return {key: x, value: x}}); 
      this.modifyAuthorizedIPs = false;
    },

    updateAuthorizedCountries() {
      let newData = this.authorizedCountriesTags.map(x => x.value);
      clientService.putClientAuthorizedCountries(this.clientView, {authorizedCountries:newData}, this.$auth.token()).then(auths => {
        this.authorizedCountries = auths.authorizedCountries;
        this.modifyAuthorizedCountries = false;
      }).catch(err => {
        this.showModal("ErrorVideos");
      })
    },
    cancelAuthorizedCountries() {
      this.authorizedCountriesTags = this.authorizedCountries.map(x => {return {key: x, value: x}}); 
      this.modifyAuthorizedCountries = false;
    },


    updateUnauthorizedIPs() {
      let newData = this.authorizedIPsTags.map(x => x.value);
      clientService.putClientUnauthorizedIPs(this.clientView, {unauthorizedIPs:newData}, this.$auth.token()).then(auths => {
        this.unauthorizedIPs = auths.unauthorizedIPs;
        this.modifyUnauthorizedIPs = false;
      }).catch(err => {
        this.showModal("ErrorVideos");
      })
    },
    cancelUnauthorizedIPs() {
      this.unauthorizedIPsTags = this.unauthorizedIPs.map(x => {return {key: x, value: x}}); 
      this.modifyUnauthorizedIPs = false;
    },

      
    updateAuthorizedVPNs() {
      clientService.putClientUnauthorizedVPNs(this.clientView, {authorizedVPNs:this.authorizedVPNs}, this.$auth.token()).then(auths => {
        this.unauthorizedVPNs = auths.unauthorizedVPNs;
      }).catch(err => {
        this.showModal("ErrorVideos");
      })
    },

    updateAuthorizedVPNsList() {
      console.log(this.authorizedVPNsTags)
      let newData = this.authorizedVPNsTags.map(x => x.value);
      console.log(newData)
      clientService.putClientAuthorizedVPNsList(this.clientView, {authorizedVPNsList:newData}, this.$auth.token()).then(auths => {
        this.authorizedVPNsList = auths.authorizedVPNsList;
        this.modifyAuthorizedVPNs = false;
      }).catch(err => {
        this.showModal("ErrorVideos");
      })
    },

    cancelAuthorizedVPNsList() {
      this.authorizedVPNsTags = this.authorizedVPNsList.map(x => {return {key: x, value: x}}); 
      this.modifyAuthorizedVPNs = false;
    },

    updateUnauthorizedCountries() {
      let newData = this.unauthorizedCountriesTags.map(x => x.value);
      clientService.putClientUnauthorizedCountries(this.clientView, {unauthorizedCountries:newData}, this.$auth.token()).then(auths => {
        this.unauthorizedCountries = auths.unauthorizedCountries;
        this.modifyUnauthorizedCountries = false;
      }).catch(err => {
        this.showModal("ErrorVideos");
      })
    },
    cancelUnauthorizedCountries() {
      this.unauthorizedCountriesTags = this.unauthorizedCountries.map(x => {return {key: x, value: x}}); 
      this.modifyUnauthorizedCountries = false;
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.myBorder {
  border: solid 2px #113448;
  border-radius: 10px;
  padding: 0px 20px 20px 20px;
}
</style>
